export type UiI18n = {
	selectPlaceholder: string;
	showPassword: string;
	hidePassword: string;
	previousYear: string;
	nextYear: string;
	noItems: string;
	loading: string;
	noResults: string;
	createNew: string;
	noItemsFound: string;
	clearFilters: string;
	remove: string;
};

export const DEFAULT_UI_I18N: UiI18n = {
	selectPlaceholder: 'Not defined',
	showPassword: 'Show password',
	hidePassword: 'Hide password',
	previousYear: 'Previous year',
	nextYear: 'Next year',
	noItems: 'No items',
	loading: 'Loading',
	noResults: 'No results',
	createNew: 'Create new',
	noItemsFound: 'No items found',
	clearFilters: 'Clear filters',
	remove: 'Remove'
};

export function createUiI18n(overrides?: Partial<UiI18n>): UiI18n {
	if (!overrides) return { ...DEFAULT_UI_I18N };
	return { ...DEFAULT_UI_I18N, ...overrides };
}
